import React, { ReactNode } from 'react';
import * as ReactDOMClient from 'react-dom/client';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

export const openReportInNewTab = (pageTitle: string, body: ReactNode, onError: (msg: string) => void, onSuccess: () => void): void => {
	const reportWindow = window.open('', '_blank');
	if (!reportWindow) {
	  onError('Unable to open report window. Please check your popup blocker settings.');
	  return;
	}

	reportWindow.document.write(`
	  <!DOCTYPE html>
	  <html>
		<head>
		  <title>${pageTitle}</title>
		  <link href="${window.location.origin}/assets/vendor/bootstrap-icons/font/bootstrap-icons.css" rel="stylesheet">
		  <link href="${window.location.origin}/assets/css/theme.min.css" rel="stylesheet">
		  <link href="${window.location.origin}/assets/css/vendor.min.css" rel="stylesheet">
		  <link href="${window.location.origin}/custom.css" rel="stylesheet">
		</head>
		<body>
		  <div id="report-root"></div>
		</body>
	  </html>
	`);

	Array.from(document.styleSheets).forEach(styleSheet => {
	  if (reportWindow.document.head !== undefined) reportWindow.document.head.appendChild(styleSheet.ownerNode!.cloneNode(true));
	});

	reportWindow.document.close();

	const emotionCache = createCache({
	  key: 'report-window',
	  container: reportWindow.document.head
	});

	const container = reportWindow.document.getElementById('report-root')!;
	const root = ReactDOMClient.createRoot(container);
	root.render(
	  <CacheProvider value={emotionCache}>
		{body}
	  </CacheProvider>
	);

	onSuccess();
}